/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Text, Depths, PrimaryButton, Spinner, SpinnerSize, Icon } from '@fluentui/react';
import { useMutation } from 'react-query';
import * as sapi from '../../services/sapi';
import theme from '../../../../theme.style';

function useAddContractIdMutation() {
  return useMutation('addContractIdToList', contractId =>
    sapi.post('/dri/add-contract-to-ingestor-list', {
      contractId,
    }),
  );
}

export default function ContractIngestionListRecommendation({ data }) {
  const { contractId } = data;
  const addContractIdMutation = useAddContractIdMutation();

  return (
    <Stack
      style={{
        display: 'inline-flex',
        backgroundColor: 'white',
        boxShadow: Depths.depth4,
        padding: 20,
      }}
      tokens={{ childrenGap: 14 }}
    >
      <Text style={{ fontWeight: 'bold' }}>Add ContractId to Ingestion List</Text>
      <Text style={{ fontWeight: 'normal' }}>
        TLA Ingestor uses a list of contractIds to query Royalty Staging DB in order to send
        transactions to calc engine. The list of contractIds is stored in an azure table storage and
        this contractId does not exist in that list and will cause ingestor to not query for this
        contractId, thus causing ingestion issues. To fix this you just need to add this contractId
        to the list using the button below.
      </Text>

      {addContractIdMutation.error && (
        <Text style={{ fontWeight: 'normal', color: theme.palette.accentError }}>
          {addContractIdMutation.error.response?.data?.message ||
            addContractIdMutation.error.message}
        </Text>
      )}

      {addContractIdMutation.isSuccess && (
        <Text style={{ fontWeight: 'normal', color: theme.palette.accentTeal }}>
          <Icon iconName="StatusCircleCheckmark" />
          Successfully added contractId to contract ingestion list.
        </Text>
      )}
      <PrimaryButton
        onClick={() => addContractIdMutation.mutate(contractId)}
        disabled={addContractIdMutation.isLoading || addContractIdMutation.isSuccess}
      >
        {addContractIdMutation.isLoading ? <Spinner size={SpinnerSize.xSmall} /> : 'Add ContractId'}
      </PrimaryButton>
    </Stack>
  );
}
ContractIngestionListRecommendation.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
